module.exports = __webpack_public_path__ + "static/media/layers.33135338.svg";